export default __webpack_public_path__ + "static/media/I_Knew_a_Guy.4c64e0dd.mp3";